import React from "react";
import { Divider } from "primereact/divider";

export const PASSWORD_POLICY_SUMMARY = "Use 12 or more characters with at least one uppercase letter, one lowercase letter, and one number.";

export const passwordHeader = <h6>Pick a password</h6>;

export const getPasswordPolicyChecks = (password: string) => {
  const value = password || "";
  return [
    {
      key: "lowercase",
      label: "At least one lowercase letter",
      matched: /[a-z]/.test(value),
    },
    {
      key: "uppercase",
      label: "At least one uppercase letter",
      matched: /[A-Z]/.test(value),
    },
    {
      key: "number",
      label: "At least one number",
      matched: /\d/.test(value),
    },
    {
      key: "length",
      label: "Minimum 12 characters",
      matched: value.length >= 12,
    },
  ];
};

type PasswordFooterProps = {
  password?: string;
};

export const PasswordPolicyFooter = ({ password = "" }: PasswordFooterProps) => {
  const checks = getPasswordPolicyChecks(password);

  return (
    <React.Fragment>
      <Divider />
      <p className="mt-2 mb-2" style={{ fontWeight: 700, color: "#334155" }}>Password requirements</p>
      <div style={{ display: "grid", gap: "0.45rem" }}>
        {checks.map((check) => (
          <div
            key={check.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              color: check.matched ? "#166534" : "#b91c1c",
            }}
          >
            <span
              aria-hidden="true"
              style={{
                width: "1.15rem",
                height: "1.15rem",
                minWidth: "1.15rem",
                borderRadius: "999px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: check.matched ? "#dcfce7" : "#fee2e2",
                border: `1px solid ${check.matched ? "#86efac" : "#fca5a5"}`,
                color: check.matched ? "#166534" : "#b91c1c",
                fontSize: "0.78rem",
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              {check.matched ? "✓" : "!"}
            </span>
            <span
              style={{
                color: check.matched ? "#166534" : "#b91c1c",
                fontWeight: check.matched ? 700 : 600,
                lineHeight: 1.4,
              }}
            >
              {check.label}
            </span>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export const passwordFooter = <PasswordPolicyFooter password="" />;
